import React from "react";
import "./ngoheader.css";
import logo from "../../images/logo/logobgremove.png";
import logotext from "../../images/logo/bgremoverelief.png";

export default function Header() {
  return (
    <div className="header-container">

      <div className="container header-inner">

        {/* LEFT: Logo + Brand */}
        <div className="logo-area">

          {/* Logo Icon */}
          <img
            src={logo}
            alt="Orrbiit"
            className="logo-icon"
          />

          {/* Brand Text Image */}
          <img
            src={logotext}
            alt="Orrbiit Relief"
            className="logo-text"
          />

        </div>

        {/* RIGHT: Donate Button */}
        <button className="donate-button">
          ❤️ Donate
        </button>

      </div>

    </div>
  );
}